import { pagesContext } from 'contexts/PagesContext';
import { useContext, useEffect, useState } from 'react';
import { CGPage } from 'types/shopify';

export const usePage = (pageHandle: string | undefined) => {
  const { loadPageByHandle } = useContext(pagesContext);
  const [page, setPage] = useState<CGPage>();

  useEffect(() => {
    (async () => {
      const p = pageHandle ? await loadPageByHandle(pageHandle) : undefined;
      setPage(p);
    })();
  }, [pageHandle, loadPageByHandle]);

  return page;
};
